import { mergeRight } from "ramda";
export const TONE_OPTIONS = [
    { text: "Friendly", value: "friendly", description: "" },
    { text: "Concise", value: "concise", description: "" },
    { text: "Formal", value: "formal", description: "" },
];
export const FONT_FAMILY_OPTIONS = [
    'Arial', 'Helvetica', 'Verdana', 'Tahoma', 'Trebuchet MS', 'Georgia',
    'Inter', 'Roboto', 'Poppins', 'Open Sans', 'Montserrat', 'Lato',
    'Source Sans 3', 'Nunito Sans', 'Work Sans', 'IBM Plex Sans', 'DM Sans',
    'Plus Jakarta Sans', 'Raleway', 'Barlow', 'PT Sans', 'Mulish', 'Rubik'
];
const formLayoutConfigOptions = {
    type: "options",
    label: "Layout",
    key: "layout",
    options: [
        {
            text: "Form",
            value: "form"
        },
        {
            text: "Chat",
            value: "chat"
        },
        // {
        //   text: "Slack",
        //   value: "slack"
        // },
        // {
        //   text: "WhatsApp",
        //   value: "whatsapp"
        // }
    ],
    defaultValue: "form"
};
const formStyleConfigOptions = {
    type: "options",
    key: "style",
    label: "Form Style",
    options: [
        {
            text: "Fluid",
            value: "fluid"
        },
        {
            text: "Classic",
            value: "classic"
        },
        {
            text: "Cards",
            value: "cards"
        },
        {
            text: "Inmersive",
            value: "inmersive"
        }
    ],
    defaultValue: "fluid"
};
const formInputModeConfigOptions = {
    type: "multipleOptions",
    key: "inputModes",
    label: "Input Modes",
    options: [
        { text: "Speech", value: "speech", description: "Use the microphone to capture audio input" },
        { text: "Camera", value: "camera", description: "Use the camera to capture video input" },
        { text: "File Upload", value: "fileUpload", description: "Use the file upload to capture file input" },
        { text: "URL Capture", value: "urlCapture", description: "Use the URL capture to capture URL input" },
        { text: "Chat", value: "chat", description: "Use the chat to capture text input" }
    ],
    defaultValue: ["speech", "camera", "fileUpload", "chat"]
};
export const stylingForm = {
    key: "styling",
    label: "Styling",
    type: "form",
    description: `Configure the style of the form.
  - Primary Colors: Impact the color of buttons, titles and other primary elements.
  - Secondary Colors: Impact the color of second and third level titles and other secondary elements.
  - Font Family: Impact the font of the form.
  - Border Radius: Impact the border radius of the form.
  - Button Size: Impact the size of the buttons.
  - Form Columns: Impact the number of columns in the form.
  `,
    fields: [
        formLayoutConfigOptions,
        formStyleConfigOptions,
        formInputModeConfigOptions,
        {
            type: "options",
            key: "chatPosition",
            label: "Chat Position",
            options: [
                { text: "Left", value: "left" },
                { text: "Right", value: "right" },
                { text: "Top", value: "top" },
                { text: "Bottom", value: "bottom" },
                { text: "Floating", value: "floating" }
            ]
        },
        {
            type: "options",
            key: "formColumns",
            label: "Form Columns",
            options: [
                { text: "1 Column", value: "1" },
                { text: "2 Columns", value: "2" },
                { text: "3 Columns", value: "3" }
            ]
        },
        {
            type: "text",
            key: "submitButtonLabel",
            label: "Submit Button Label",
            description: "Text displayed on the form submit button",
            defaultValue: "Submit"
        },
        {
            type: "options",
            key: "chatType",
            label: "Chat Type",
            options: [
                { text: "Conversational", value: "conversational" },
                // {text: "Micro-forms", value: "microforms"}
            ]
        },
        // {
        //   type: "integer",
        //   key: "microFormsFieldCount",
        //   label: "Fields per Micro-form",
        //   description: "Number of fields to show per micro-form (1-5)",
        //   defaultValue: 1
        // },
        {
            type: "yesno",
            key: "showBranding",
            label: "Show Branding",
            description: "Show 'Powered by FluidForm' branding"
        },
        {
            type: "yesno",
            key: "collapseProgressPanel",
            label: "Collapse Progress Panel",
            description: "Collapse the progress panel in Fluid layout",
            defaultValue: false
        },
        {
            type: "options",
            key: "defaultMode",
            label: "Default Mode",
            description: "Default display mode for Fluid layout",
            options: [
                { text: "Form + Chat", value: "form-chat" },
                { text: "Form", value: "form" },
                { text: "Chat", value: "chat" }
            ],
            defaultValue: "form-chat"
        },
        {
            type: "composedList",
            key: "globalStyles",
            label: "Global Styles",
            fields: [
                {
                    type: "text",
                    key: "primaryColor",
                    label: "Primary Color",
                    description: "Hex color code (e.g. #f97316, #3b82f6). Impacts buttons, titles and other primary elements."
                },
                {
                    type: "text",
                    key: "backgroundColor",
                    label: "Background Color",
                    description: "Hex color code (e.g. #ffffff, #f3f4f6, #1f2937). Impacts the background color of the form."
                },
                {
                    type: "text",
                    key: "fontFamily",
                    label: "Font Family",
                    description: `Font name. Available: ${FONT_FAMILY_OPTIONS.join(', ')}`
                },
                {
                    type: "text",
                    key: "fontColor",
                    label: "Font Color",
                    description: "Hex color code (e.g. #000000, #1f2937, #ffffff). Impacts the text color throughout the form."
                },
                {
                    type: "options",
                    key: "borderRadius",
                    label: "Border Radius",
                    options: [
                        { text: "None", value: "none" },
                        { text: "Small", value: "small" },
                        { text: "Medium", value: "medium" },
                        { text: "Large", value: "large" }
                    ]
                },
                {
                    type: "options",
                    key: "buttonStyle",
                    label: "Button Style",
                    description: "Border and main style of the buttons, not the color.",
                    options: [
                        { text: "Filled", value: "filled" },
                        { text: "Outline", value: "outline" },
                        { text: "Ghost", value: "ghost" },
                        { text: "Link", value: "link" }
                    ]
                },
                {
                    type: "options",
                    key: "buttonSize",
                    label: "Button Size",
                    options: [
                        { text: "Small", value: "small" },
                        { text: "Medium", value: "medium" },
                        { text: "Large", value: "large" }
                    ]
                },
                {
                    type: "text",
                    key: "chatUserBubbleColor",
                    label: "Chat User Bubble Color",
                    description: "Hex color code (e.g. #dbeafe). Background color for user chat bubbles."
                },
                {
                    type: "text",
                    key: "chatUserBubbleFontColor",
                    label: "Chat User Bubble Font Color",
                    description: "Hex color code (e.g. #1f2937). Text color for user chat bubbles."
                },
                {
                    type: "text",
                    key: "chatAssistantBubbleColor",
                    label: "Chat Assistant Bubble Color",
                    description: "Hex color code (e.g. #fed7aa). Background color for assistant chat bubbles."
                },
                {
                    type: "text",
                    key: "chatAssistantBubbleFontColor",
                    label: "Chat Assistant Bubble Font Color",
                    description: "Hex color code (e.g. #1f2937). Text color for assistant chat bubbles."
                }
            ],
            maxFields: 1,
            minFields: 1
        },
        {
            type: "composedList",
            key: "chatOptions",
            label: "Chat Options",
            fields: [
                {
                    key: "autoStart", type: "yesno", label: "Auto Start",
                    description: "Automatically start the chat after the form is submitted"
                },
                {
                    key: "tone", type: "options", label: "Tone",
                    description: "",
                    options: TONE_OPTIONS,
                    defaultValue: "friendly"
                },
                {
                    key: "initialMessage", type: "text", label: "Initial Message", longText: true,
                    description: "The message to display at the beginning of the form"
                },
                {
                    key: "finalMessage", type: "text", label: "Final Message", longText: true,
                    description: "The message to display at the end of the form"
                },
            ]
        },
        {
            type: "composedList",
            key: "postSubmissionActions",
            label: "Post-Submission Actions",
            fields: [
                {
                    type: "options",
                    key: "action",
                    label: "Action Type",
                    options: [
                        { text: "Thank You Screen", value: "thank_you" },
                        { text: "Redirect", value: "redirect" }
                    ],
                    defaultValue: "thank_you"
                },
                {
                    type: "text",
                    key: "thankYouMessage",
                    label: "Thank You Message",
                    description: "Message shown on the thank you screen",
                    defaultValue: "Thank you for your submission!"
                },
                {
                    type: "text",
                    key: "redirectUrl",
                    label: "Redirect URL",
                    description: "URL to redirect to after form submission"
                },
                // {
                //   type: "yesno",
                //   key: "showConfetti",
                //   label: "Show Confetti",
                //   description: "Show confetti animation on success"
                // },
                {
                    type: "yesno",
                    key: "showSocialShare",
                    label: "Show Social Share",
                    description: "Show social media sharing buttons"
                },
                {
                    type: "yesno",
                    key: "ctaButtonEnabled",
                    label: "Enable CTA Button",
                    description: "Show a call-to-action button"
                },
                {
                    type: "text",
                    key: "ctaButtonText",
                    label: "CTA Button Text",
                    description: "Text for the call-to-action button"
                },
                {
                    type: "text",
                    key: "ctaButtonUrl",
                    label: "CTA Button URL",
                    description: "URL for the call-to-action button"
                }
            ],
            maxFields: 1,
            minFields: 1
        },
        {
            type: "composedList",
            key: "fieldStylesConfigurations",
            label: "Field Styles Configurations",
            fields: [
                {
                    type: "text",
                    key: "configName",
                    label: "Config Name",
                    description: "Name of the field to configure"
                },
                {
                    type: "multipleOptions",
                    key: "composed-visibleFields",
                    label: "Keys of the Visible Fields in Table View",
                    description: "Number of fields to show in a table view of composed fields"
                },
            ]
        }
    ]
};
// Default Post-Submission Actions
export const DefaultPostSubmissionActions = {
    action: "thank_you",
    thankYouMessage: "Thank you for your submission!",
    redirectUrl: "",
    // showConfetti: true,
    showSocialShare: false,
    ctaButtonEnabled: false,
    ctaButtonText: "Visit our website",
    ctaButtonUrl: ""
};
// Helper function to get post-submission actions with defaults
export const getPostSubmissionActions = (form) => {
    const currentActions = form.getValue("postSubmissionActions.0");
    const formActions = (typeof currentActions === 'object' && currentActions !== null && !Array.isArray(currentActions)) ? currentActions : {};
    return mergeRight(DefaultPostSubmissionActions, formActions);
};
// Helper function to get post-submission actions from config service
export const getPostSubmissionActionsFromConfig = (configService) => {
    const postSubmissionConfig = configService.getAdditionalConfigValue("styleConfig", "postSubmissionActions")?.[0] || {};
    return mergeRight(DefaultPostSubmissionActions, postSubmissionConfig);
};
export const getChatOptions = (form) => {
    const currentOptions = form.getValue("chatOptions.0");
    const formOptions = (typeof currentOptions === 'object' && currentOptions !== null && !Array.isArray(currentOptions)) ? currentOptions : {};
    return formOptions;
};
export const getChatOptionsFromConfig = (configService) => {
    const chatOptionsConfig = configService.getAdditionalConfigValue("styleConfig", "chatOptions")?.[0] || {};
    return chatOptionsConfig;
};
export const DEFAULT_STYLING_OPTIONS = {
    primaryColor: '#f97316',
    backgroundColor: '#ffffff',
    fontFamily: 'Inter',
    fontColor: '#000000',
    borderRadius: 'medium',
    buttonStyle: 'filled',
    buttonSize: 'medium',
    chatUserBubbleColor: '#dbeafe',
    chatUserBubbleFontColor: '#1f2937',
    chatAssistantBubbleColor: '#fed7aa',
    chatAssistantBubbleFontColor: '#1f2937'
};
export const COLOR_NAME_TO_HEX = {
    red: '#ef4444',
    blue: '#3b82f6',
    green: '#22c55e',
    purple: '#a855f7',
    orange: '#f97316',
    black: '#000000',
    white: '#ffffff',
    'dark gray': '#1f2937',
    'light gray': '#f3f4f6',
    yellow: '#eab308',
    pink: '#ec4899',
    teal: '#14b8a6',
    indigo: '#6366f1',
};
export const PREDEFINED_THEMES = [
    {
        name: 'Fluid',
        description: 'Clean and vibrant with orange accents',
        keywords: ['default', 'fluid', 'orange'],
        styles: {
            primaryColor: '#f97316',
            backgroundColor: '#ffffff',
            fontFamily: 'Inter',
            fontColor: '#1f2937',
            borderRadius: 'medium',
            buttonStyle: 'filled',
            buttonSize: 'medium',
            chatUserBubbleColor: '#dbeafe',
            chatUserBubbleFontColor: '#1f2937',
            chatAssistantBubbleColor: '#fed7aa',
            chatAssistantBubbleFontColor: '#1f2937'
        }
    },
    {
        name: 'Professional Blue',
        description: 'Corporate and trustworthy',
        keywords: ['professional', 'corporate', 'blue', 'business'],
        styles: {
            primaryColor: '#3b82f6',
            backgroundColor: '#f9fafb',
            fontFamily: 'Roboto',
            fontColor: '#111827',
            borderRadius: 'small',
            buttonStyle: 'filled',
            buttonSize: 'medium',
            chatUserBubbleColor: '#dbeafe',
            chatUserBubbleFontColor: '#1f2937',
            chatAssistantBubbleColor: '#d1fae5',
            chatAssistantBubbleFontColor: '#1f2937'
        }
    },
    {
        name: 'Soft Purple',
        description: 'Creative and elegant',
        keywords: ['creative', 'elegant', 'purple', 'soft'],
        styles: {
            primaryColor: '#a855f7',
            backgroundColor: '#faf5ff',
            fontFamily: 'Poppins',
            fontColor: '#4b5563',
            borderRadius: 'large',
            buttonStyle: 'filled',
            buttonSize: 'medium',
            chatUserBubbleColor: '#e0e7ff',
            chatUserBubbleFontColor: '#4b5563',
            chatAssistantBubbleColor: '#f3e8ff',
            chatAssistantBubbleFontColor: '#4b5563'
        }
    },
    {
        name: 'Minimalist',
        description: 'Clean and simple with subtle styling',
        keywords: ['minimalist', 'clean', 'simple', 'minimal'],
        styles: {
            primaryColor: '#1f2937',
            backgroundColor: '#ffffff',
            fontFamily: 'Inter',
            fontColor: '#000000',
            borderRadius: 'small',
            buttonStyle: 'outline',
            buttonSize: 'medium',
            chatUserBubbleColor: '#f1f5f9',
            chatUserBubbleFontColor: '#1f2937',
            chatAssistantBubbleColor: '#e5e7eb',
            chatAssistantBubbleFontColor: '#1f2937'
        }
    },
    {
        name: 'Solarized',
        description: 'Easy on the eyes with warm accents',
        keywords: ['solarized', 'warm', 'easy'],
        styles: {
            primaryColor: '#268bd2',
            backgroundColor: '#fffcee',
            fontFamily: 'Roboto',
            fontColor: '#3a5863',
            borderRadius: 'small',
            buttonStyle: 'filled',
            buttonSize: 'medium',
            chatUserBubbleColor: '#fef3c7',
            chatUserBubbleFontColor: '#3a5863',
            chatAssistantBubbleColor: '#bfdbfe',
            chatAssistantBubbleFontColor: '#3a5863'
        }
    },
    {
        name: 'Dark Mode',
        description: 'Easy on the eyes with dark backgrounds',
        keywords: ['dark', 'dark mode', 'night'],
        styles: {
            primaryColor: '#3b82f6',
            backgroundColor: '#1f2937',
            fontFamily: 'Inter',
            fontColor: '#ffffff',
            borderRadius: 'medium',
            buttonStyle: 'filled',
            buttonSize: 'medium',
            chatUserBubbleColor: '#ffffff',
            chatUserBubbleFontColor: '#1f2937',
            chatAssistantBubbleColor: '#ffffff',
            chatAssistantBubbleFontColor: '#1f2937'
        }
    }
];
/**
 * Builds LLM instructions for styling from the shared constants.
 * Used by the backend AI agent so instructions stay in sync with theme/font/color definitions.
 */
export function buildStylingInstructions() {
    const colorMappings = Object.entries(COLOR_NAME_TO_HEX)
        .map(([name, hex]) => `${name}=${hex}`)
        .join(', ');
    const fontList = FONT_FAMILY_OPTIONS.join(', ');
    const themeLines = PREDEFINED_THEMES.map(t => {
        const props = Object.entries(t.styles)
            .map(([k, v]) => `${k}=${v}`)
            .join(', ');
        const kw = t.keywords.join(', ');
        return `- "${t.name}" (keywords: ${kw}): ${props}`;
    }).join('\n');
    return [
        "All color values MUST be 6-digit hex color codes prefixed with # (e.g. #f97316, #3b82f6, #ffffff). Never use color names like 'red' or 'blue' - always convert to hex.",
        `Common color mappings: ${colorMappings}.`,
        `Available font families: ${fontList}. Always use the exact font name from this list.`,
        `When the user asks for a theme or a general style, apply the full set of globalStyles properties. Available predefined themes:\n${themeLines}`,
        "The 'globalStyles' field is a composedList. Its value must be an array with exactly one object containing the style properties. Example: { \"globalStyles\": [{ \"primaryColor\": \"#f97316\", \"backgroundColor\": \"#ffffff\", \"fontFamily\": \"Inter\" }] }",
        "The 'chatOptions' field is also a composedList. Its value must be an array with one object. Example: { \"chatOptions\": [{ \"autoStart\": true, \"tone\": \"friendly\", \"initialMessage\": \"Hello!\" }] }",
        "The 'postSubmissionActions' field is also a composedList. Its value must be an array with one object. Example: { \"postSubmissionActions\": [{ \"action\": \"thank_you\", \"thankYouMessage\": \"Thanks!\" }] }",
        "When the user requests a specific styling change (e.g. 'make the primary color blue'), only include the changed fields in the output. Do not reset other fields to defaults.",
        "When the user asks for a complete theme change, include all globalStyles properties in the output.",
    ];
}
